import { Download } from '@mui/icons-material'
import { Button, IconButton } from '@mui/material'
import { useRef, useState } from 'react'
import { DownloadMenu } from '@/features/search/SearchResults/actions/DownloadMenu'
import type { FileAttachment } from '@/features/search/types'

type Props = {
  files: FileAttachment[]
  mediaCode: number
}

export const DownloadAction = (props: Props) => {
  const ref = useRef(null)
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Button ref={ref} onClick={handleOpen} title="Download">
        <Download />
      </Button>
      <DownloadMenu
        open={open}
        onClose={handleClose}
        anchorEl={ref.current}
        mediaCode={props.mediaCode}
        files={props.files}
      />
    </>
  )
}
